import React, { forwardRef } from 'react';
import type { AlertTitleProps } from '@mui/material';
import { AlertTitle as AlertTitleMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

const AlertTitle = forwardRef<HTMLSpanElement, AlertTitleProps>((props, ref) => (
  <AlertTitleMUI
    {...omitUndefinedProps(props)}
    ref={(node) => {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    }}
  />
));

AlertTitle.displayName = 'AlertTitle';

export default AlertTitle;
